const allProps = [
  'margin',
  'm',
  'marginTop',
  'mt',
  'marginBottom',
  'mb',
  'marginLeft',
  'ml',
  'marginRight',
  'mr',
  'mx',
  'my',
  'padding',
  'p',
  'paddingTop',
  'pt',
  'paddingBottom',
  'pb',
  'paddingLeft',
  'pl',
  'paddingRight',
  'pr',
  'px',
  'py',
  'width',
  'fontSize',
  'fontFamily',
  'fontWeight',
  'lineHeight',
  'textAlign',
  'fontStyle',
  'letterSpacing',
  'display',
  'maxWidth',
  'minWidth',
  'height',
  'maxHeight',
  'minHeight',
  'color',
  'backgroundColor',
  'bg',
  'verticalAlign',
  'alignItems',
  'alignContent',
  'justifyItems',
  'justifyContent',
  'flexWrap',
  'flexBasis',
  'flexDirection',
  'flex',
  'justifySelf',
  'alignSelf',
  'order',
  'gridGap',
  'gridColumnGap',
  'gridRowGap',
  'gridColumn',
  'gridRow',
  'gridAutoFlow',
  'gridAutoColumns',
  'gridAutoRows',
  'gridTemplateColumns',
  'gridTemplateRows',
  'gridTemplateAreas',
  'gridArea',
  'border',
  'borderWidth',
  'borderStyle',
  'borderColor',
  'borderTop',
  'borderRight',
  'borderBottom',
  'borderLeft',
  'borderRadius',
  'boxShadow',
  'opacity',
  'overflow',
  'background',
  'backgroundImage',
  'backgroundSize',
  'backgroundPosition',
  'backgroundRepeat',
  'position',
  'zIndex',
  'top',
  'right',
  'bottom',
  'left',
];

const blacklist = [
  ...allProps,
  'transform',
  'transition',
  'overflow',
  'opacity',
  'alpha',
  'hoverColor',
  'hoverBg',
  'hoverBorder',
  'zOrder',
  'pointerEvents',
  'whiteSpace',
];

export default blacklist

export const cleanConfig = {
  shouldForwardProp: (prop, defaultValidatorFn) =>
    !blacklist.includes(prop)
    && defaultValidatorFn(prop),
}

